import React, { useEffect, useState } from "react";
import "../../../index.css";
import { get, SOCKET_URL } from "../../../constants/apiRoutes.js";
import LiveRateTable from "../TableComponents/LiveRateTable.jsx";
import Tabs from "../TableComponents/Tabs.jsx";

const ViewBroadcast = () => {
  const [liveData, setLiveData] = useState([]);
  const [socketData, setsocketData] = useState([]);
  const token = localStorage.getItem("jwtToken");
  const websocketUrl = `${SOCKET_URL}?token=${token}`;

  const liveHeadings = [
    "24K Rate",
    "22K Rate",
    "21K Rate",
    "18K Rate",
    "14K Rate",
    "Timestamp",
  ];

  useEffect(() => {
    
    fetchLiveRate();

    let ws = new WebSocket(websocketUrl);

    ws.onopen = () => console.log("WebSocket connection opened");

    ws.onmessage = (event) => {
            
      const data = JSON.parse(event.data);
      setsocketData(data);
      
    };

    ws.onerror = (error) => console.error("WebSocket error:", error);

    // return () => {
    //   ws.close();
    // };
  }, [websocketUrl]);


  const fetchLiveRate = async () => {
    try {
      const response = await get(`Rates/latest`);
      setLiveData(response);
    } catch (error) {
      console.error(`Error While Fetching Live Rate : ${error}`);
    }
  };

  return (
    <div className="user-dashboard m-4">
      <div className="wsData m-3">
        <div className="overflow-x-auto">
          <LiveRateTable
            data={socketData.length ? socketData : liveData}
            headings={liveHeadings}
          />
        </div>

        <Tabs />
      </div>
    </div>
  );
};

export default ViewBroadcast;
